import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MessageService, SelectItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

import {ReportGeneratorService} from '../../../../../services/apiServices/business/report-generator.service';
import {CustomerGroup} from '../../../../../model/customer-group';
import {UserManagementService} from '../../../../../services/apiServices/business/user-management.service';
import {CustomerUser} from '../../../../../model/customer-user';
import {CustomDate} from '../../../../../model/custom-date';
import {Calendar} from 'primeng/calendar';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../../services/apiServices/business/common.service';

/**
 * Component that handle request saving (including updates)
 */
@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GenerateReportComponent implements OnInit {
  @ViewChild('customPeriodCal', {static: false}) customPeriodCal: Calendar;
  /**
   * Output Binding for modal opening
   */
    // tslint:disable-next-line:no-output-rename
  @Output('displayComponentChange') public displayComponentChange: EventEmitter<boolean>;
  @Input('displayComponent') public displayComponent: boolean;
  public selectedDates: Date[];
  public generateButtonDisabled: boolean;
  public fieldLabels: any;
  public yearRange=[new Date('2012-01-01'), new Date()];
  public availableCols: any[];
  public selectedCols: any[];
  groupList: SelectItem[];
  selectedGroup: string;
  validStatus: boolean;
  subTotalField: any;
  availableTotalFields: any[];
  availableGroupFields: any[];
  totalFields: any[];
  userList: SelectItem[];
  operations: SelectItem[];
  selectedUser: CustomerUser;
  cols: any[];
  reportTypes: SelectItem[];
  selectedReportType: string;
  newTotalField: any;
  includeDataSheet: boolean;
  showAddTotalField: boolean;
  public error_title: string;
  public error_body: string;

  /**
   * instantiate variables
   * @param reportService
   * @param {CommonService} commonService - handle notifications
   * @param {TranslateService} translateService - handle translation for component
   * @param userManagementService
   */
  constructor(private reportService: ReportGeneratorService, private commonService: CommonService,
              private fileSaverService: FileSaverService,
              private translateService: TranslateService, private userManagementService: UserManagementService) {
    this.displayComponentChange = new EventEmitter<boolean>();
  }

  /**
   * Init variables
   */
  public ngOnInit(): void {
    this.generateButtonDisabled = true;
    this.validStatus = true;
    this.includeDataSheet = false;
    this.selectedReportType = 'DETAILED';
    this.fieldLabels = {};
    const emptyGroup = new CustomerGroup();
    emptyGroup.sGrpUserID = '_NA_';
    emptyGroup.sGrpUserLabel = '';
    this.showAddTotalField = false;
    this.newTotalField = {
      field: '',
      operation: ''
    };
    this.groupList = [];
    this.userList = null;
    this.operations = [
      {label: '', value: '_NA_'},
      {label: 'Somme de valeurs', value: 'SUM'},
      {label: 'Nombre de valeurs', value: 'COUNT'}
    ];
    this.cols = [
      {field: 'name', header: 'GENERATE_REPORT.TF_NAME', width: '45%'},
      {field: 'operation', header: 'GENERATE_REPORT.TF_OPER', width: '45%'}
    ];
    this.reportTypes = [];
    this.translateService.get('GENERATE_REPORT.REPORT_TYPE_SYNTHETIC').subscribe(label => {
      this.reportTypes.push({label: label, value: 'SYNTHETIC'});
    });
    this.translateService.get('GENERATE_REPORT.REPORT_TYPE_DETAILED').subscribe(label => {
      this.reportTypes.push({label: label, value: 'DETAILED'});
    });

    this.groupList.unshift({label: '', value: '_NA_'});
    this.availableCols = [];
    this.selectedCols = [];
    this.getTradForComponent();
    this.selectedDates = null;

    this.initCols();
    this.userManagementService.listCustomerGroups().subscribe(res => {
      if (res) {
        const listGroups = res.sort((a, b) => {
          const nameA = a.sGrpUserID.toUpperCase();
          const nameB = b.sGrpUserID.toUpperCase();
          let comparison = 0;
          if (nameA > nameB) {
            comparison = 1;
          } else if (nameA < nameB) {
            comparison = -1;
          }
          return comparison;
        }).filter((element, index) => {
          return element.sGrpUserID
            && element.sGrpUserID.toUpperCase() !== 'DEPOSIT'
            && element.sGrpUserID.toUpperCase() !== 'SUPPORT'
            && element.sGrpUserID.toUpperCase() !== 'ADMINAPP';
        });
        this.groupList = [{label: 'Aucun', value: '_NA_'}];
        for (const grp of listGroups) {
          this.groupList.push({
            label: grp.sGrpUserLabel + ' [' + grp.sGrpUserID + ']',
            value: grp.sGrpUserID
          });
        }
      }
    });
  }
  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translateService.get('VIRTUAL_PRINTER.CONFIRM_DELETE.ERROR_TITLE').subscribe((res: string) => {
      this.error_title = res;
    });
    this.translateService.get('VIRTUAL_PRINTER.CONFIRM_DELETE.ERROR_BODY').subscribe((res: string) => {
      this.error_body = res;
    });
  }

  public dateSelected(): void {
    if (this.selectedDates[0] && this.selectedDates[1]) {
      this.customPeriodCal.overlayVisible = false;
    }

  }

  setReportColumns(fields: any[]): void {
    this.availableCols = fields;
    for (const field of fields) {
      this.fieldLabels[field.field] = field.label;
    }
  }

  public initCols(): void {
    this.reportService.getReportColumns('').subscribe(fields => {
      this.setReportColumns(fields);
    });
  }

  selectGroup(): void {
    if (this.selectedGroup === '_NA_') {
      this.userList = [{
        label: '',
        value: '_NA_'
      }];
      return;
    }
    this.userManagementService.getCustomerGroupUsers(this.selectedGroup).subscribe(result => {
      this.userList = [{
        label: '',
        value: '_NA_'
      }];
      if (result && result.length > 0) {
        for (const usr of result) {
          this.userList.push({
            label: usr.sUserFirstName + ' ' + usr.sUserLastName + ' [' + usr.sUserID + ']',
            value: usr.sUserID
          });
        }
      }
    });
    this.reportService.getReportColumns(this.selectedGroup).subscribe(fields => {
      this.setReportColumns(fields);
    });
  }

  initTotalFields(): void {
    this.totalFields = [];
    this.availableTotalFields = [];
    this.availableGroupFields = [];
    this.availableGroupFields.push({
      field: '_NA_',
      label: ''
    });
    this.subTotalField = null;
    for (const field of this.selectedCols) {
      this.availableGroupFields.push(field);
    }
  }

  initSubTotalFields(): void {
    this.totalFields = [];
    this.availableTotalFields = [];
    for (const field of this.availableGroupFields) {
      if (field.field !== this.subTotalField.field) {
        this.availableTotalFields.push(field);
      }
    }
  }

  displayAddTotalField(): void {
    this.newTotalField = {
      field: '',
      operation: ''
    };
    this.showAddTotalField = true;
  }

  hideAddTotalField(): void {
    this.showAddTotalField = false;
  }

  setNewTotalFieldName(event): void {
    this.newTotalField.field = event.value.field;
  }

  setNewTotalFieldValue(event): void {
    this.newTotalField.operation = event.value;
  }

  saveTotalField(): void {
    this.totalFields.push(this.newTotalField);
    this.newTotalField = {field: '', operation: ''};
    this.showAddTotalField = false;
  }

  /*
  public createReport(agregatedFields: any[], reportFields: any[], groupingField: string, groupId: string, userId: string, startDate: string, endDate: string): Observable<any> {
   */
  generateReport(): void {
    let groupId = '';
    if (this.selectedGroup && this.selectedGroup !== '_NA_') {
      groupId = this.selectedGroup;
    }
    let userId = '';
    if (this.selectedUser && this.selectedUser.sUserID !== '_NA_') {
      userId = this.selectedUser.sUserID;
    }
    let groupingField = '';
    if (this.subTotalField && this.subTotalField.field !== '_NA_') {
      groupingField = this.subTotalField.field;
    }
    const dataToSend = JSON.stringify({
      reportFields: this.availableCols,
      selectedFields: this.selectedCols,
      groupingField: groupingField,
      aggregatedFields: this.totalFields,
      groupId: groupId,
      userId: userId,
      startDate: CustomDate.format(this.selectedDates[0]),
      endDate: CustomDate.format(this.selectedDates[1]),
      validStatus: this.validStatus,
      reportType: this.selectedReportType,
      includeDataSheet: this.includeDataSheet
    });
    this.reportService.createReport(dataToSend).subscribe(response => {
      const h = response.headers.get('content-type');

      if (h.startsWith('application/xls')) {
        if (response.body.size > 0) {
          const fileName = response.headers.get('content-disposition').split(';')[1].split('=')[1];
          const blob = new Blob([response.body], {endings: 'native', type: response.headers.get('content-type')});
          this.fileSaverService.save(blob, fileName);
        } else {
          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.error_title,
            detail: this.error_body + ' ( ' + response.sMsgError + ' ).'
          });
        }
      } else if (h.startsWith('application/json')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const msg = JSON.parse((<any>e.target).result);

          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.error_title,
            detail: this.error_body + ' ( ' + msg.sMsgError + ' ).'
          });
        };

        reader.readAsText(response.body);
      }
    });
  }

  deleteTotalField(index): void {
    this.totalFields.splice(index, 1);
  }

  disableBtn(): boolean {
    this.generateButtonDisabled = false;
    if (!this.selectedDates || this.selectedDates.length < 2) {
      this.generateButtonDisabled = true;
    }
    if (this.selectedCols.length < 1) {
      this.generateButtonDisabled = true;
    }
    if (this.subTotalField && this.subTotalField.field && this.subTotalField.field !== '_NA_') {
      if (this.totalFields.length < 1) {
        this.generateButtonDisabled = true;
      }
    }
    return this.generateButtonDisabled;
  }

  logItem(item: any) {
  }
}
